import { Link, Stack } from "@mui/material";

export default function FooterLink({ children }) {
    return (
        <Link underline="none" color='#fff' fontWeight={300} fontSize={14}>
            <Stack direction='row' gap={0.5}>
                {children}
            </Stack>
        </Link>
    )
}
